export default __webpack_public_path__ + "static/media/AA Posters_1_Web Size.3d132c5c.jpg";